import { useSyncExternalStore } from 'react'
import { pubSub } from '../../app-state/pubSub'
import { getUsersState } from '../../app-state/state.users'
import { UserEvent } from '../../constants/enums'

const subModelsLoaded = (callback: () => void) =>
    pubSub.USERS.on(UserEvent.MODELS_LOADED, callback)
const getModelsLoaded = () => getUsersState().modelsLoaded

export const useModelsLoadedAppState = () => {
    const modelsLoaded = useSyncExternalStore(
        subModelsLoaded,
        getModelsLoaded,
        getModelsLoaded,
    )

    return modelsLoaded
}
